import React from 'react';
import LazyPageLoader from '../../../cmp/LazyPageLoader';

const Page = React.lazy(()=>import('./W9FormWizard'))

function LazyW9Page(props){
    return <React.Suspense fallback={<LazyPageLoader />}>
        <Page />
    </React.Suspense>
}


export default LazyW9Page
